
export class UomPricingSchemeModel {
    price_name: string;
    price_amount_incl_tax: string | 0;                
    price_amount_excl_tax:string | 0; 
    uom: string;
    guid: string;
    guid_pricing_scheme_hdr: string;
    isBaseUom: boolean;
}